import { APIService } from "./api";
import { API } from "@/lib/api";
import { AgreementType } from "@/types/agreementType";

export const AgreementTypeService = new APIService<AgreementType>(
  API.AgreementTypes,
);
export const fetchAgreementTypeList = AgreementTypeService.getList;
